import { render } from "./ManageLabels.vue?vue&type=template&id=3c64d594"
import script from "./ManageLabels.vue?vue&type=script&lang=js"
export * from "./ManageLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__